const Saga = {
  init(target) {
    const sagaCards = target.querySelectorAll('.sagacard')
    const allCards = {}

    document.addEventListener('scroll', () => this.onScroll(allCards))
    window.addEventListener('load', () => this.onScroll(allCards))
    window.addEventListener('resize', () => this.onScroll(allCards))

    sagaCards.forEach((el) => {
      const positions = el.getBoundingClientRect()
      allCards[positions.top] = el
    })
  },
  onScroll(allCards) {
    const { scrollY } = window

    Object.entries(allCards).forEach(([key, val]) => {
      const htmlEl = val as HTMLElement
      const keyNum = parseInt(key, 10)

      if (scrollY + 350 > keyNum) {
        htmlEl.classList.add('sagacard--dark')
      } else {
        htmlEl.classList.remove('sagacard--dark')
      }
    })
  },
}

export default Saga
